import { useMemo } from "react";

import dayjs from "@/common/utils/dayjs";
import { Granularity } from "@reflag/shared/featureAPI";

export function useAdoptionChartFormatters(granularity: Granularity) {
  return useMemo(() => {
    let formatter: (epoch: number) => string;
    let tooltipFormatter: (epoch: number) => string;
    switch (granularity) {
      case "minute":
        formatter = (epoch: number) => {
          return dayjs.unix(epoch).format("HH:mm");
        };
        tooltipFormatter = (epoch: number) => {
          return dayjs.unix(epoch).format("HH:mm, MMM D, YYYY");
        };
        break;
      case "hour":
        formatter = (epoch: number) => {
          if (dayjs.unix(epoch).isSame(dayjs(), "day")) {
            return "Today";
          }
          return dayjs.unix(epoch).format("MMM D");
        };
        tooltipFormatter = (epoch: number) => {
          return dayjs.unix(epoch).format("HH:mm, MMM D, YYYY");
        };
        break;
      case "week":
        formatter = (epoch: number) => {
          if (dayjs.unix(epoch).isSame(dayjs(), "week")) {
            return "This week";
          }
          return `Week ${dayjs.unix(epoch).week()}`;
        };
        tooltipFormatter = (epoch: number) => {
          const startOfWeek = dayjs.unix(epoch).startOf("week");
          const endOfWeek = dayjs.unix(epoch).endOf("week");
          const weekRange = `${startOfWeek.format("MMM D")} - ${endOfWeek.format("MMM D, YYYY")}`;
          return `Week ${dayjs.unix(epoch).week()}, ${weekRange}`;
        };
        break;
      default:
        formatter = (epoch: number) => {
          if (dayjs.unix(epoch).isSame(dayjs(), "day")) {
            return "Today";
          }
          return dayjs.unix(epoch).format("MMM D");
        };
        tooltipFormatter = (epoch: number) => {
          return dayjs.unix(epoch).format("MMM D, YYYY");
        };
        break;
    }
    return { formatter, tooltipFormatter };
  }, [granularity]);
}
